const contactConstants = {
  CONTACT_REQUEST: 'CONTACT_REQUEST',
  CONTACT_SUCCESS: 'CONTACT_SUCCESS',
  CONTACT_FAILURE: 'CONTACT_FAILURE',
  CONTACT_RESET: 'CONTACT_RESET',
};
export default contactConstants;
